import { type Tag } from '../pages/Blog/Blog.types'

export function getBlogCategoryName(tags: Tag[], handle: string): string {
  return tags.find((tag) => tag.data?.handle === handle)?.data?.name ?? ''
}
